export const ArrowEdgeFlowZIndexes = {
  edge: 1,
  node: 2,
} as const satisfies Record<'edge' | 'node', number>;
